/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email': {
    width: 24,
    height: 17,
    viewBox: '0 0 24 17',
    data: '<path pid="0" d="M1.33 14.86l7.677-6.955L1.33 2.08v12.78zM1.874 0h20.252A1.88 1.88 0 0124 1.902v13.255c0 1.01-.847 1.843-1.874 1.843H1.874C.847 17 0 16.168 0 15.157V1.902A1.88 1.88 0 011.874 0zm.786 1.367l7.798 5.944c.906.713 2.116.713 3.083 0l7.738-5.944H2.66zm19.95.714l-7.556 5.766 7.556 6.955V2.08zM21.52 15.633l-7.617-6.955c-1.21.653-2.6.653-3.808 0l-7.617 6.955H21.52z" _fill="#9C380E"/>'
  }
})
